import { Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class AlertService {
  public alertOpen = signal<boolean>(false);
  public alertMsg = signal<string>("");
  public alertType = signal<string>("danger");
  public alertTimeout = signal<string>("5000");

  dismissible = signal<boolean>(false);

  showError(payload: any) {
    this.alertType.set("danger");
    this.alertMsg.set(payload.msg);
    this.alertOpen.set(true);
    this.alertTimeout.set("5000");
    this.show(payload);
  }

  showWarning(payload: any) {
    this.alertType.set("warning");
    this.alertTimeout.set("5000");
    this.show(payload);
  }

  showInfo(payload: any) {
    this.alertType.set("info");
    this.alertTimeout.set("5000");
    this.show(payload);
  }

  showSuccess(payload: any) {
    this.alertType.set("success");
    this.alertTimeout.set("5000");
    this.show(payload);
  }

  private show(payload: any) {
    this.alertMsg.set(payload.msg);
    if (payload.timeout) this.alertTimeout.set(payload.timeout);
    else this.alertTimeout.set("5000");
    this.alertOpen.set(true);

    // TODO: remove workaround for dismissOnTimeout not working
    const timeout = parseInt(this.alertTimeout());
    if (timeout > 0) {
      setTimeout(() => {
        this.alertOpen.set(false);
      }, timeout);
    }
  }

  clear() {
    this.alertType.set("danger");
    this.alertMsg.set("");
    this.alertOpen.set(false);
    this.alertTimeout.set("15000");
  }
}
